import { useContext, useMemo, useState } from 'react'

import { Box, Icon, Text, Timeline } from '@fairfashion/design-system'

import { IItemTraceabilityStep } from '../../../../sdk/finished-item-profile/finished-item-profile.types'
import { QRCodeDetailsContext } from '../../qrcode-details.context'
import { EditItemTraceabilityStepModal } from '../EditItemTraceabilityStepModal/edit-item-traceability-step-modal.comp'
import { ItemTraceabilityStepCard } from '../ItemTraceabilityStepCard/item-traceability-step-card.comp'

export const QRCodeDetailsJourney = () => {
  const [editItemTraceabilityStep, setEditItemTraceabilityStep] =
    useState<IItemTraceabilityStep>()

  const { itemTraceabilitySteps } = useContext(QRCodeDetailsContext)

  const timelineItems = useMemo(() => {
    const steps = []
    steps.push({
      color: 'success',
      marker: <Icon name="circle_fill" size={36} color="secondary" />,
      content: (
        <Box direction="column" paddingBottom={3}>
          <Box height="36px" alignItems="center">
            <Text fontWeight={500} color="success" size="small">
              INÍCIO
            </Text>
          </Box>
        </Box>
      ),
    })

    itemTraceabilitySteps
      ?.sort((a, b) => b.order - a.order)
      .forEach((its) => {
        steps.push({
          color: 'success',
          marker: (
            <Box
              alignItems="center"
              justifyContent="center"
              gap={1}
              width="36px"
              height="36px"
              borderRadius="100%"
              border={{ color: 'secondary', width: 2 }}
            >
              <Icon name="circle_fill" size={16} color="secondary" />
            </Box>
          ),
          content: (
            <ItemTraceabilityStepCard
              itemTraceabilityStep={its}
              onEdit={() => setEditItemTraceabilityStep(its)}
            />
          ),
        })
      })

    steps.push({
      color: 'success',
      marker: <Icon name="circle_fill" size={36} color="secondary" />,
      content: (
        <Box height="36px" alignItems="center">
          <Text fontWeight={500} color="success" size="small">
            FIM
          </Text>
        </Box>
      ),
    })

    return steps
  }, [itemTraceabilitySteps])

  if (!itemTraceabilitySteps?.length) return null

  return (
    <Box direction="column" width="100%" gap={2}>
      <Text fontWeight={500}>Jornada</Text>

      <Timeline items={timelineItems as any} />

      <EditItemTraceabilityStepModal
        open={!!editItemTraceabilityStep}
        onClose={() => setEditItemTraceabilityStep(undefined)}
        itemTraceabilityStep={editItemTraceabilityStep}
      />
    </Box>
  )
}
